import { Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'components/Auth/Auth';
import ButtonLink from 'components/theme_components/ButtonLink';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import InputCurrency from 'components/InputCurrency';
import Notifications from 'components/theme_components/Notifications';
import { TpAuthorizationResponse } from 'services/thirdParty';

export type ActivityModalProps = {
  form: FormInstance;
  onDone: any;
  onCancel: any;
  dataInput: TpAuthorizationResponse;
};

const TabUpdateMPEAAmount = ({
  form,
  onDone,
  onCancel,
  dataInput,
}: ActivityModalProps) => {
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    if (dataInput && dataInput.authDetail) {
      form.setFieldsValue({
        authid: dataInput.authid,
        event: 'TabUpdateMPEAAmount',
        authcalculatedamount: dataInput.authcalculatedamount,
      });
    }
  }, [dataInput]);

  const validateFields = () => {
    form
      .validateFields()
      .then(() => {
        Notifications({
          status: 'error',
          message:
            'La demande est transmise a votre manager vous serez informé lors de la validation',
          duration: 1,
          placement: 'top',
        });

        // Return a promise that resolves after a delay
        return new Promise((resolve) => setTimeout(resolve, 1500));
      })
      .then(() => {
        onDone();
      });
  };
  return (
    <div>
      <FormInput
        col
        xs={24}
        lg={24}
        name="authcalculatedamount"
        labelCol={{ span: 24 }}
        className="no-border-radius ut-activaty-custom-antd-from"
        rules={[
          {
            required: true,
            validator: (_, value) => {
              if (dataInput.authamount <= value) {
                return Promise.resolve();
              } else {
                return Promise.reject(
                  new Error(
                    'le montant de la MPEA doit être superieur ou égale au montant du normal limit '
                  )
                );
              }
            },
          },
        ]}
      >
        <InputCurrency
          className="ut-input-modal ut-activaty-custom-input"
          min={dataInput.authamount}
        />
      </FormInput>

      <Row justify={'end'} style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          // onClick={() => setVisible(false)}
          onClick={() => !isInspect && onCancel()}
        />
        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn"
          onClick={() => !isInspect && setModalVisible(true)}
          iconPosition="end"
        />
        <ConfirmModal
          visible={modalVisible}
          status="error"
          message={
            'Souhaitez vous modifier la limite MPEA ' +
            dataInput.authcalculatedamount +
            ' € à ' +
            form.getFieldValue('authcalculatedamount') +
            ' € ? '
          }
          onConfirm={() => {
            setModalVisible(false);
            validateFields();
          }}
          onCancel={() => !isInspect && setModalVisible(false)}
          className="modalConfirmOrCancel"
        />
      </Row>
    </div>
  );
};

export default TabUpdateMPEAAmount;
